package com.klantenstop.web.data.models.dto.responses

import com.klantenstop.web.data.models.domain.Status
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CompanyDto(
    val id: String = "",
    val slug: String = "",
    val name: String = "",
    val description: String = "",
    val address: AddressDto? = null,
    val verified: Boolean = false,
    @SerialName("phone_number")
    val phoneNumber: String = "",
    @SerialName("email_address")
    val emailAddress: String = "",
    val website: String = "",
    val logo: MediaFileDto? = null,
    val status: StatusDto = StatusDto(),
    val categories: List<CategoryDto> = emptyList(),
    @SerialName("created_at")
    val createdAt: String = "",
    @SerialName("updated_at")
    val updatedAt: String = ""
)

@Serializable
data class AddressDto(
    val id: String = "",
    @SerialName("street_name")
    val streetName: String = "",
    @SerialName("street_number")
    val streetNumber: String = "",
    @SerialName("zip_code")
    val zipCode: String = "",
    val city: String = "",
    val province: String = "",
    val country: String = "",
    val coordinates: CoordinatesDto = CoordinatesDto(),
    @SerialName("created_at")
    val createdAt: String = "",
    @SerialName("updated_at")
    val updatedAt: String = ""
)

@Serializable
data class CoordinatesDto(
    val latitude: Double = 0.0,
    val longitude: Double = 0.0
)

@Serializable
data class StatusDto(
    val id: String = "",
    val text: String = "",
    val status: Status.Type = Status.Type.Unknown,
    val company: CompanyDto? = null,
    @SerialName("created_at")
    val createdAt: String = "",
    @SerialName("updated_at")
    val updatedAt: String = ""
)
